import { faTimesCircle } from "@fortawesome/pro-regular-svg-icons/faTimesCircle";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconTimesCircle: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faTimesCircle} />;
};
